module.exports = __webpack_public_path__ + "static/media/envelope.2ae9f25b.svg";